<!DOCTYPE html>
<html>
  <head>
    <title>Legal Management</title>
  </head>

  <body>
    <div class="p-0 container-fluid">
      <div class="m-0 row">
        <div class="p-0 col-md-6">
          <div class="login_left_bar">
            <div class="left_content">
              <h1>Welcome to Redleaf Legal Mangement</h1>
              <p>
                Manage your legal cases easily with e-Court integration and grow
                your business with our powerful legal software.
              </p>
            </div>
          </div>
        </div>
        <div class="p-0 col-md-6">
          <div class="login-card login-dark">
            <div>
              <div>
                <a class="logo text-center" href="">
                  <img
                    src="assets/resources/images/Redleaf.png"
                    alt="darkLogo"
                    class="img-fluid for-dark media"
                  />
                </a>
              </div>
              <div class="login-main">
                <h3 class="panel-title">Forgot Password</h3>
                <form
                  #formData="ngForm"
                  accept-charset="UTF-8"
                  role="form"
                  (ngSubmit)="onClickSubmit(formData.value)"
                >
                  <fieldset>
                    <div class="form-group">
                      <input
                        class="form-control"
                        placeholder="Enter Code"
                        name="usercode"
                        type="text"
                        ngModel
                      />
                    </div>
                    <div class="form-group">
                      <input
                        class="form-control"
                        placeholder="Enter User Name"
                        name="username"
                        type="text"
                        ngModel
                      />
                    </div>
                    <div class="form-group center">OR</div>
                    <div class="form-group">
                      <input
                        class="form-control"
                        placeholder="Enter Registerred Email Id"
                        name="emailId"
                        type="text"
                        ngModel
                      />
                    </div>
                    <div class="form-group">
                      <input
                        class="btn btn-primary btn-block"
                        type="submit"
                        value="Submit"
                      />
                    </div>
                  </fieldset>
                </form>
                <br />
                <div *ngIf="showMsg" style="padding-left: 10px">
                  <span class="{{ class }}">{{ this.Msg }}</span>
                </div>
                <div class="" style="display: flex; justify-content: center;">
                  <input
                    class="btn btn-link"
                    (click)="goToPage()"
                    type="submit"
                    value="Login"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
